import classnames from 'classnames';

interface Props {
  errorMessage: string | null;
  fullWidth?: boolean;
  children: React.ReactNode;
}
const Error: React.FC<Props> = ({
  errorMessage,
  children = null,
  fullWidth,
}) => {
  const reloadPage = () => document.location.reload();

  const errorClass = classnames({
    'flex border border-red-800 rounded-md bg-red-50 py-4 px-5': true,
    'w-full': fullWidth,
    'w-4/5  mx-auto': !fullWidth,
  });

  return (
    <>
      {errorMessage ? (
        <div className={errorClass}>
          <div className="">
            <img src="/error-icon.svg" className="h-6 w-6" alt="Error icon" />
          </div>
          <div className="ml-5">
            <p className="text-base text-red-700 ">{errorMessage}</p>

            <p
              onClick={reloadPage}
              className="text-base text-red-700 hover:text-red-600 font-semibold cursor-pointer transition ease-in-out duration-150 mt-8"
            >
              Refresh the page
            </p>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default Error;
